import script from "./entries-table-data-provider.vue?vue&type=script&setup=true&lang=ts"
export * from "./entries-table-data-provider.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__